import React, { createContext, useContext } from 'react';

/**
 * Product-specific wiring for the block renderer: the defaults for `socialShare`
 * blocks. The `socialShareCarousel` block itself lives in `@core/frontend/ui` and is
 * registered directly in the renderer, so it is not part of this contract.
 *
 * Campaigns provide it once at the app root instead of threading the values through
 * every page, rotation and consent renderer. Without a provider the shared defaults
 * apply (`SocialShareBar`'s own defaults).
 */
const BlockRendererConfigContext = createContext({});

export const BlockRendererConfigProvider = ({ value, children }) => (
    <BlockRendererConfigContext.Provider value={value}>{children}</BlockRendererConfigContext.Provider>
);

export const useBlockRendererConfig = () => useContext(BlockRendererConfigContext);
